import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';

import {
  GET_CONTACT_TYPES,
  GET_CONTACT_TYPES_SUCCESS,
  GET_CONTACT_TYPES_FAIL,
} from "../actions/contactTypes";

const initialState = {
  contactTypes: [],
  contactTypesById: {},
};

const ADDITIONAL_CONTACT_TYPES = [{
  id: "skype",
  name: "Skype"
}, {
  id: "phone",
  name: "Phone"
}];

export default function contactTypes(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONTACT_TYPES:
      return {
        ...state,
        isLoading: true,
      }

    case GET_CONTACT_TYPES_SUCCESS:
      const contactTypes = [
        ...ADDITIONAL_CONTACT_TYPES,
        ...(action.response.contactType || [])
      ];
      const contactTypesById = mapObjectize(contactTypes);
      return {
        ...state,
        contactTypes: mapIds(contactTypes),
        contactTypesById,
        isLoading: false,
        isLoaded: true,
      }

    case GET_CONTACT_TYPES_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
      }

    default:
      return state;
  }
}
